import { render } from "./IncomeReport.vue?vue&type=template&id=491b8f9c&scoped=true"
import script from "./IncomeReport.vue?vue&type=script&lang=js"
export * from "./IncomeReport.vue?vue&type=script&lang=js"

import "./IncomeReport.vue?vue&type=style&index=0&id=491b8f9c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-491b8f9c"]])

export default __exports__